import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';

@Component({
  selector: 'app-navigation-menu',
  standalone: true,
  imports: [TranslateModule, NzMenuModule, RouterModule],
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss'],
})
export class NavigationMenuComponent implements OnInit {
  @Input({ required: true }) links: Array<string> = [];
  @Input({ required: true }) translationEntryPoint?: string;
  constructor() {}

  ngOnInit() {}

  protected replaceDashes(navigationLink: string): string {
    return navigationLink.replace(/-/g, '_');
  }
}

